export const GET_PO_LISTING_REQUEST = "GET_PO_LISTING_REQUEST";
export const GET_PO_LISTING_SUCCESS = "GET_PO_LISTING_SUCCESS";
export const GET_PO_LISTING_FAILURE = "GET_PO_LISTING_FAILURE";

export const GET_PO_PROCESS_LOG_REQUEST = "GET_PO_PROCESS_LOG_REQUEST";
export const GET_PO_PROCESS_LOG_SUCCESS = "GET_PO_PROCESS_LOG_SUCCESS";
export const GET_PO_PROCESS_LOG_FAILURE = "GET_PO_PROCESS_LOG_FAILURE";

export const GET_ROUTING_INFO_BY_PO_REQUEST = "GET_ROUTING_INFO_BY_PO_REQUEST";
export const GET_ROUTING_INFO_BY_PO_SUCCESS = "GET_ROUTING_INFO_BY_PO_SUCCESS";
export const GET_ROUTING_INFO_BY_PO_FAILURE = "GET_ROUTING_INFO_BY_PO_FAILURE";

export const PUT_RELEASE_PO_REQUEST = "PUT_RELEASE_PO_REQUEST";
export const PUT_RELEASE_PO_SUCCESS = "PUT_RELEASE_PO_SUCCESS";
export const PUT_RELEASE_PO_FAILURE = "PUT_RELEASE_PO_FAILURE";

export const GET_PO_PROCESS_LOG_REPORTS_REQUEST =
  "GET_PO_PROCESS_LOG_REPORTS_REQUEST";
export const GET_PO_PROCESS_LOG_REPORTS_SUCCESS =
  "GET_PO_PROCESS_LOG_REPORTS_SUCCESS";
export const GET_PO_PROCESS_LOG_REPORTS_FAILURE =
  "GET_PO_PROCESS_LOG_REPORTS_FAILURE";

export const UPDATE_SUB_CONTRACTING_REQUEST = "UPDATE_SUB_CONTRACTING_REQUEST";
export const UPDATE_SUB_CONTRACTING_SUCCESS = "UPDATE_SUB_CONTRACTING_SUCCESS";
export const UPDATE_SUB_CONTRACTING_FAILURE = "UPDATE_SUB_CONTRACTING_FAILURE";

export const GET_OPERATIONS_LIST_BY_PO_REQUEST =
  "GET_OPERATIONS_LIST_BY_PO_REQUEST";
export const GET_OPERATIONS_LIST_BY_PO_SUCCESS =
  "GET_OPERATIONS_LIST_BY_PO_SUCCESS";
export const GET_OPERATIONS_LIST_BY_PO_FAILURE =
  "GET_OPERATIONS_LIST_BY_PO_FAILURE";

export const UPDATE_DEPENDENCY_REQUEST = "UPDATE_DEPENDENCY_REQUEST";
export const UPDATE_DEPENDENCY_SUCCESS = "UPDATE_DEPENDENCY_SUCCESS";
export const UPDATE_DEPENDENCY_FAILURE = "UPDATE_DEPENDENCY_FAILURE";

export const UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_REQUEST =
  "UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_REQUEST";
export const UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_SUCCESS =
  "UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_SUCCESS";
export const UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_FAILURE =
  "UPDATE_SUB_CONTRACTING_FOR_PO_ROUTING_FAILURE";

export const GET_PO_LISTING_WITHOUT_PAGINATION_REQUEST =
  "GET_PO_LISTING_WITHOUT_PAGINATION_REQUEST";
export const GET_PO_LISTING_WITHOUT_PAGINATION_SUCCESS =
  "GET_PO_LISTING_WITHOUT_PAGINATION_SUCCESS";
export const GET_PO_LISTING_WITHOUT_PAGINATION_FAILURE =
  "GET_PO_LISTING_WITHOUT_PAGINATION_FAILURE";

export const UPLOADCSV_FOR_PO_LISTING_REQUEST =
  "UPLOADCSV_FOR_PO_LISTING_REQUEST";
export const UPLOADCSV_FOR_PO_LISTING_SUCCESS =
  "UPLOADCSV_FOR_PO_LISTING_SUCCESS";
export const UPLOADCSV_FOR_PO_LISTING_FAILURE =
  "UPLOADCSV_FOR_PO_LISTING_FAILURE";

export const GET_COMPLETED_PO_LISTING_REQUEST =
  "GET_COMPLETED_PO_LISTING_REQUEST";
export const GET_COMPLETED_PO_LISTING_SUCCESS =
  "GET_COMPLETED_PO_LISTING_SUCCESS";
export const GET_COMPLETED_PO_LISTING_FAILURE =
  "GET_COMPLETED_PO_LISTING_FAILURE";

export const POST_REPORT_TO_ERP_REQUEST = "POST_REPORT_TO_ERP_REQUEST";
export const POST_REPORT_TO_ERP_SUCCESS = "POST_REPORT_TO_ERP_SUCCESS";
export const POST_REPORT_TO_ERP_FAILURE = "POST_REPORT_TO_ERP_FAILURE";

export const GET_CONSUMED_SUIDS_REQUEST = "GET_CONSUMED_SUIDS_REQUEST";
export const GET_CONSUMED_SUIDS_SUCCESS = "GET_CONSUMED_SUIDS_SUCCESS";
export const GET_CONSUMED_SUIDS_FAILURE = "GET_CONSUMED_SUIDS_FAILURE";
